import {
  Component,
  ContentChildren,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Optional,
  Renderer2,
  Self,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormGroupDirective, NgControl } from '@angular/forms';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'gl-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.component.scss'],
    standalone: false
})
export class RadioButtonComponent implements OnInit, ControlValueAccessor {
  public startingValue: any;
  @Input() public name: string;
  @Input() public value: any;
  @Input() public labelOnLeftSide: boolean;
  @Input() public defaultChecked: boolean;
  @ViewChild('input', { static: true, read: ElementRef })
  public input: ElementRef<HTMLInputElement>;
  @ContentChildren(IconComponent) public icons;

  constructor(
    @Optional()
    @Self()
    public controlDir: NgControl,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    @Optional() public parentFormGroup: FormGroupDirective,
  ) {
    if (controlDir) {
      controlDir.valueAccessor = this;
    }
  }

  @HostBinding('class.checked') get checked() {
    return this.input.nativeElement.checked;
  }

  @HostListener('click', ['$event']) public onclick(event: MouseEvent) {
    event.preventDefault();
    this.propagateChange(this.value);
    this.setCheckedForInput();
  }

  public ngOnInit() {
    if (this.value === this.startingValue) {
      this.setCheckedForInput();
    }

    if (this.defaultChecked) {
      this.setCheckedForInput();
    }
  }

  public registerOnChange(fn: any): any {
    this.propagateChange = fn;
  }

  public registerOnTouched = (_: any) => undefined;

  public writeValue(value: any): void {
    this.startingValue = value;
    if (value === true) {
      this.setCheckedForInput();
    } else {
      this.renderer.setProperty(this.input.nativeElement, 'checked', false);
    }
    this.renderer.setProperty(this.input.nativeElement, 'value', value);
  }

  public setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  private propagateChange = (_: any) => undefined;

  private setCheckedForInput() {
    this.renderer.setProperty(this.input.nativeElement, 'checked', true);
  }
}
